import { useTranslation } from 'react-i18next';

type CreditsSectionProps = {
  title: string;
  entries: Array<{ label: string; href?: string }>;
};

function CreditsSection({ title, entries }: CreditsSectionProps) {
  return (
    <section className="credits-section">
      <h3 className="credits-section-title">{title}</h3>
      <ul className="credits-section-list">
        {entries.map((entry) => (
          <li key={entry.label}>
            {entry.href ? (
              <a href={entry.href} target="_blank" rel="noreferrer">
                {entry.label}
              </a>
            ) : (
              entry.label
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}

export function CreditsTab() {
  const { t } = useTranslation('menus');

  return (
    <div className="credits-tab" data-testid="settings-credits-tab">
      <div className="credits-header">{t('credits.title')}</div>
      <CreditsSection
        title={t('credits.developedBy')}
        entries={[{ label: 'Cotovelo Games', href: 'https://cotovelogames.com/' }]}
      />
      <CreditsSection
        title={t('credits.developedWith')}
        entries={[
          { label: 'Excalibur.js', href: 'https://excaliburjs.com/' },
          { label: 'Babylon.js', href: 'https://www.babylonjs.com/' },
          { label: 'Gemshell', href: 'https://gemshell.dev/' },
        ]}
      />
      <CreditsSection
        title={t('credits.bigThanksTo')}
        entries={[
          { label: 'bhardal' },
          { label: 'mookie' },
          { label: 'berlinoor' },
          { label: 'regohole' },
          { label: 'Akabarcia' },
          { label: 'Safire2342' },
          { label: t('credits.andYou') },
        ]}
      />
    </div>
  );
}
